import {
    Component, OnDestroy, OnInit, ViewEncapsulation, NgZone, ElementRef, inject, Output, EventEmitter
} from '@angular/core';
import {SolrEntity} from "@signature-it/ngx-entity/models";
import {ActivatedRoute, Router} from "@angular/router";
import { EventData,EventName } from "@signature-it/ngx-generic/classes";
import {RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';
import { SeoService_Generic, LanguageService, FeaturesService, EventBusService, ShareDataService as ShareDataServiceGeneric } from '@signature-it/ngx-generic/services'
import {ILanguage } from '@signature-it/ngx-generic/interfaces';
import {DictionaryTermDTO } from '@signature-it/ngx-generic/models';
import {EntityService, SolrEntityService, EntityPageService} from "@signature-it/ngx-entity/services";
import {Observable, Subject} from "rxjs";
import {SolrOptionsEntityDTO} from "@signature-it/ngx-entity/models";
import {takeUntil} from "rxjs/operators";


@Component({
    selector: 'entity-page-base',
    templateUrl: './entity-page-base.component.html',
    styleUrls: ['./entity-page-base.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EntityPageBaseComponent implements OnInit, OnDestroy {
    entityId: number;
    html;
    scripts;
    entity: SolrEntity;
	protected currLang: Observable<ILanguage>;
	type: string;
    dcTerms: Array<DictionaryTermDTO>;
    highlightDictionaryTerms: boolean = false;
    navUri;
    contentUri;
    activeRouteSnapshot;
    dataTemplate: any;
    protected destroy$: Subject<void> = new Subject<void>();
    routerComp: string;
    $containerEl;
    item;
    @Output() loadBlock: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected activatedRoute: ActivatedRoute;
    protected entityService: EntityService;
    protected solrEntityService: SolrEntityService;
    protected router: Router;
    protected seoSvc: SeoService_Generic;
    protected config: RestUrlsConfig;
    protected langSvc: LanguageService;
    protected featuresSvc: FeaturesService;
    protected entityPageService: EntityPageService;
    protected ngZone: NgZone;
    protected eventBusService: EventBusService;
    protected shareDataGeneric: ShareDataServiceGeneric;
    constructor() {
        this.activatedRoute = inject(ActivatedRoute);
        this.entityService = inject(EntityService);
        this.solrEntityService = inject(SolrEntityService);
        this.router = inject(Router);
        this.seoSvc = inject(SeoService_Generic);
        this.config = inject(RestUrlsConfig);
        this.langSvc = inject(LanguageService);
        this.featuresSvc = inject(FeaturesService);
        this.entityPageService = inject(EntityPageService);
        this.ngZone = inject(NgZone);
        this.eventBusService = inject(EventBusService);
        this.shareDataGeneric = inject(ShareDataServiceGeneric);
        this.currLang = this.langSvc.getCurrentLanguage$();
		this.currLang = this.langSvc.getCurrentLanguage$();
    }

    ngOnInit() {}

    getDictionaryTerms() {
        this.entityService.getDictionaryTerms().pipe(takeUntil(this.destroy$)).subscribe(res => {
            this.dcTerms = res;
        })
    }

    getRedirectUrl() {
        let url = this.router.url;
        this.featuresSvc.getRedirectUrl(url).pipe(takeUntil(this.destroy$)).subscribe((path) => {
            if (path) {
                this.router.navigate([path.split('?')[0]]);
            } else {
                this.router.navigate([`/404`]);
            }
        });
    }

    HTMLtags(str){
        const scriptsReg = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
        this.scripts = str.match(scriptsReg)?.join('');
        this.html = str;
    }


    getSolrEntity(uri, entityVar = null, redirect = true) {
        const solrOptions = new SolrOptionsEntityDTO({
            entityUri: uri,
            entityVar: entityVar,
        });
        this.solrEntityService.getSolr(solrOptions).pipe(takeUntil(this.destroy$)).subscribe(
            solrResponse => {
                    if (solrResponse?.response?.docs[0]?.page_content_lg) {
                        this.setTemplatePageData(solrResponse);

                    } else if(redirect) {
                        this.getRedirectUrl();
                    }
            }
        );
    }


    setTemplatePageData(solrResponse) {
        const doc = solrResponse && solrResponse.response? solrResponse.response.docs[0] : {};
        this.item = doc;
        this.dataTemplate = doc;
        if(doc.product_pic_s) {
            this.seoSvc.setOgTag('image', this.config.beURL + solrResponse.response['docs'][0]['product_pic_s']);
        }
        if(doc.seo_title_s) {
            const seoTitle = (GenericConfig.distributionChannelId ? doc['seo_title_dc_' + GenericConfig.distributionChannelId + '_s'] : '') || doc.seo_title_s;
            const seoDescription = (GenericConfig.distributionChannelId ? doc['seo_description_dc_' + GenericConfig.distributionChannelId + '_s'] : '') || doc.seo_description_s;
            this.seoSvc.setSeo(seoTitle, seoDescription);
        }
        if(doc.seo_no_index_i){
            this.seoSvc.setNoIndexNoFollow();
        }
        if (solrResponse?.response?.docs[0]?.page_content_lg) {
            let data = solrResponse?.response?.docs[0]?.page_content_lg;
            data = this.b64DecodeUnicode(data);
            if (data && Object.keys(data).length !== 0) {
                this.HTMLtags(data);
            }
            this.highlightDictionaryTerms = solrResponse.response.docs[0].highlight_dictionary_terms_i;
            if (this.highlightDictionaryTerms) {
                this.getDictionaryTerms();
            }
        }
                               this.loadBlock.emit(true);

    }

    b64DecodeUnicode(str) {
        try {
            return decodeURIComponent(Array.prototype.map?.call(atob(str), function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } catch (e) {
            return '';
        }
    }

    ngOnDestroy() {
        this.shareDataGeneric.showBreadcrumbs$.next(true);
        this.entityPageService.mainEntity = null;
        this.seoSvc.setOgTag('type', 'website');
        this.destroy$.next();
        this.destroy$.complete();
    }

    scrollToAnchor(params) {
        if(params.anc) {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    let el = document.getElementById(params.anc);
                    if(el) {
                        el.scrollIntoView(true);
                        let scrolledY = window.scrollY;
                        if(scrolledY){
                            let header = document.querySelector('#ngx-header')
                            let headerHeight = header ? header['offsetHeight'] + 5 : 0;
                            window.scroll(0, scrolledY - headerHeight);
                        }
                    }

                }, 1000);
            });
        }
    }
}
